import type { Routes } from '@angular/router';
import { CreateTenantComponent } from './modules/create-tenant/create-tenant.component';
import { DwsComponent } from './modules/dws/dws.component';
import { HomeComponent } from './modules/home/home.component';
import { KwhComponent } from './modules/kwh/kwh.component';
import { KwsComponent } from './modules/kws/kws.component';
import { OverviewComponent } from './modules/overview/overview.component';
import { SustainabilityComponent } from './modules/sustainability/sustainability.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [],
      },
      {
        path: 'overview',
        component: OverviewComponent,
        canActivate: [],
      },
      {
        path: 'kws',
        component: KwsComponent,
        canActivate: [],
      },
      {
        path: 'dws',
        component: DwsComponent,
        canActivate: [],
      },
      {
        path: 'createTenant',
        component: CreateTenantComponent,
        canActivate: [],
      },
      {
        path: 'kwh',
        component: KwhComponent,
        canActivate: [],
      },
      {
        path: 'sustainability',
        component: SustainabilityComponent,
        canActivate: [],
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'home',
      },
    ],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
